import { Departament } from "./departament";
import { HolidayPool } from "./holidayPool";

export enum CalendarValidatorError {
  END_DATE_PREV = 'END_DATE_PREV',
  HOLIDAY_DATES = 'HOLIDAY_DATES',
  EVENT_EXISTS = 'EVENT_EXISTS',
  OVER_LIMITS = 'OVER_LIMITS'
}

export enum CalendarStatus {
  ACCEPTED = 'aceptada',
  PENDING = 'pendiente',
  REJECTED = 'cancelada'
}

export enum CalendarReason {
  HOLIDAYS = 'vacaciones',
  PERSONAL_MATTERS = 'asuntos propios',
  SICK_LEAVE = 'baja laboral',
  PAID_LEAVE = 'permiso retribuido',
  REMOTE_WORK = 'teletrabajo'
}

export class Calendar {
  public id?: number
  public reason: string
  public start_date: string
  public end_date: string
  public status: string
  public rejection_reason: string
}

export class CalendarSuperUpdate {
  public status: string
  public rejection_reason: string | null

  constructor(status: string, rejectionReason: string | null) {
    this.status = status
    this.rejection_reason = rejectionReason
  }
}

export class UserCalendar {
  public id?: number
  public dni: string
  public username: string
  public name: string
  public user_id: number
  public calendars: Calendar[]
}

export class UserCalendarDTO extends UserCalendar {
  public departament: Departament
  public holidayPools: HolidayPool[]
}

export class CalendarLeyend {
  public type: string
  public text: string

  constructor(type: string, text: string) {
    this.type = type
    this.text = text
  }
}

export class CalendarRange {
  public startDate: string
  public endDate: string

  constructor(startDate: string, endDate: string) {
    this.startDate = startDate
    this.endDate = endDate
  }
}
